import escapeTextContentForBrowser from "escape-html";
import { z } from "zod";

import { customEmojiSchema } from "./custom-emoji";
import { dateSchema, filteredArray } from "./utils";

const pollOptionSchema = z.object({
  title: z.string().catch(""),
  votes_count: z.number().catch(0),
  title_emojified: z.string().catch(""),
});

const pollSchema = z
  .object({
    emojis: filteredArray(customEmojiSchema),
    expired: z.boolean().catch(false),
    expires_at: dateSchema,
    expires_in: z.string().optional(),
    id: z.string(),
    multiple: z.boolean().catch(false),
    options: z.array(pollOptionSchema).min(2),
    voters_count: z.number().catch(0),
    votes_count: z.number().catch(0),
    own_votes: z.array(z.number()).nonempty().nullable().catch(null),
    voted: z.boolean().catch(false),
    pleroma: z
      .object({
        non_anonymous: z.boolean().catch(false),
      })
      .optional()
      .catch(undefined),
  })
  .transform((poll) => {
    const emojifiedOptions = poll.options.map((option) => ({
      ...option,
      title_emojified: escapeTextContentForBrowser(option.title),
    }));

    // If the user has votes, they have certainly voted.
    if (poll.own_votes?.length) {
      poll.voted = true;
    }

    return {
      ...poll,
      options: emojifiedOptions,
    };
  });

type Poll = z.infer<typeof pollSchema>;
type PollOption = Poll["options"][number];

export { pollSchema, pollOptionSchema, type Poll, type PollOption };
